<template>
  <div class="uploadCSVComponent d_grid gap_30">
    <label
      class="uploadZone"
      for="csvUploadFile"
      v-on:dragover="dragover"
      v-on:dragleave="dragleave"
      v-on:drop="drop"
      v-bind:style="dragZoneStyle"
    >
      <span style="white-space: pre-wrap;">{{ uploadedTxt }}</span>
    </label>

    <input id="csvUploadFile" class="d_none" type="file" name="files[]" multiple v-on:change="setFile" ref="inputFile" v-bind:disabled="disabled">

    <button class="js-openModal el_btn el_btn__green fs_15 fw_b btnShadow_shadow_green el_btn__icon el_btn__round" v-on:click="uploadConfirm" type="button" v-show="isSet">
      <svg class="icon_style">
        <use xlink:href="/svg/symbol-defs.svg#icon-upload" />
      </svg>
      アップロード
    </button>

    <modal-window init-on-click-open-class="js-openModal">
      <template v-slot:main_content>
        <div class="uploadCSVComponent_confirm">

          <div class="uploadCSVComponent_confirm_loading" v-if="isUploading">
            <img class="uploadCSVComponent_confirm_loading_img" src="/svg/oval.svg" alt="">
            <span class="uploadCSVComponent_confirm_loading_txt">
              アップロード中
              <span class="">大きいファイルだと1~2分ほど<br>時間が掛かることがあります</span>
            </span>
          </div>

          <div class="" v-else-if="isSuccess">
            データの反映が完了しました！
          </div>

          <div class="uploadCSVComponent_confirm_error" v-else-if="isError">
            エラーが発生しました。
            再度アップロードしてください。

            <p>
              エラー内容
              {{ errorMessage }}
            </p>
          </div>

          <div class="uploadCSVComponent_confirm_wrap" v-else>
            <!-- <button v-show="!insertTargetEstates.length >= 1 && !updateTargetEstates.length >= 1" class="uploadCSVComponent_confirm_submit el_btn el_btn__gray fs_20 fw_b btnShadow_shadow_gray el_btn__round" type="button" disabled>
              新規登録・更新対象のデータが無いため更新できません
            </button> -->

            <button class="uploadCSVComponent_confirm_submit el_btn el_btn__green fs_20 fw_b btnShadow_shadow_green el_btn__round" v-on:click="uploadStore" type="button">
              データベースを更新する
            </button>

            <!-- TODO:長いため、圧縮の必要あり -->
            <div class="uploadCSVComponent_confirm_table_list">
              <h2 class="col_red">新規登録対象  {{ insertTargetEstates.length }}件</h2>
              <div class="uploadCSVComponent_confirm_table_wrap mt_10">
                <div class="uploadCSVComponent_confirm_table">
                  <div class="uploadCSVComponent_confirm_table_row uploadCSVComponent_confirm_table__red">
                    <div class="uploadCSVComponent_confirm_table_td">管理番号</div>
                    <div class="uploadCSVComponent_confirm_table_td">REINS 物件番号</div>
                    <div class="uploadCSVComponent_confirm_table_td">掲載状況</div>
                    <div class="uploadCSVComponent_confirm_table_td">登録者</div>
                    <div class="uploadCSVComponent_confirm_table_td">物件種別</div>
                    <div class="uploadCSVComponent_confirm_table_td">物件名</div>
                    <div class="uploadCSVComponent_confirm_table_td">物件公開</div>
                    <div class="uploadCSVComponent_confirm_table_td">取引形態</div>
                    <div class="uploadCSVComponent_confirm_table_td">価格</div>
                    <div class="uploadCSVComponent_confirm_table_td">利回り</div>
                    <div class="uploadCSVComponent_confirm_table_td">年間賃貸収入</div>
                    <!-- <div class="uploadCSVComponent_confirm_table_td">郵便番号</div> -->
                    <div class="uploadCSVComponent_confirm_table_td">都道府県</div>
                    <div class="uploadCSVComponent_confirm_table_td">市区町村</div>
                    <div class="uploadCSVComponent_confirm_table_td">町域・番地以降</div>
                    <div class="uploadCSVComponent_confirm_table_td">交通</div>
                    <div class="uploadCSVComponent_confirm_table_td">交通の徒歩時間</div>
                    <div class="uploadCSVComponent_confirm_table_td">構造</div>
                    <div class="uploadCSVComponent_confirm_table_td">構造（補足）</div>
                    <div class="uploadCSVComponent_confirm_table_td">階数</div>
                    <div class="uploadCSVComponent_confirm_table_td">築年月（西暦）</div>
                    <div class="uploadCSVComponent_confirm_table_td">建築確認番号</div>
                    <div class="uploadCSVComponent_confirm_table_td">建築面積</div>
                    <div class="uploadCSVComponent_confirm_table_td">総戸数</div>
                    <div class="uploadCSVComponent_confirm_table_td">間取り</div>
                    <div class="uploadCSVComponent_confirm_table_td">駐車場</div>
                    <div class="uploadCSVComponent_confirm_table_td">駐車場台数</div>
                    <div class="uploadCSVComponent_confirm_table_td">施工会社</div>
                    <div class="uploadCSVComponent_confirm_table_td">土地権利</div>
                    <div class="uploadCSVComponent_confirm_table_td">地目</div>
                    <div class="uploadCSVComponent_confirm_table_td">地勢</div>
                    <div class="uploadCSVComponent_confirm_table_td">土地面積</div>
                    <div class="uploadCSVComponent_confirm_table_td">セットバック</div>
                    <div class="uploadCSVComponent_confirm_table_td">私道負担面積</div>
                    <div class="uploadCSVComponent_confirm_table_td">都市計画</div>
                    <div class="uploadCSVComponent_confirm_table_td">用途地域/建ぺい率/容積率</div>
                    <div class="uploadCSVComponent_confirm_table_td">接道状況/接道種別/接道方角/接道幅員</div>
                    <div class="uploadCSVComponent_confirm_table_td">現況</div>
                    <div class="uploadCSVComponent_confirm_table_td">引渡時期</div>
                    <div class="uploadCSVComponent_confirm_table_td">ガス</div>
                    <div class="uploadCSVComponent_confirm_table_td">水道</div>
                    <div class="uploadCSVComponent_confirm_table_td">下水</div>
                    <div class="uploadCSVComponent_confirm_table_td">備考</div>
                    <div class="uploadCSVComponent_confirm_table_td">元付業者　会社名</div>
                    <div class="uploadCSVComponent_confirm_table_td">元付業者　電話番号</div>
                    <div class="uploadCSVComponent_confirm_table_td">元付担当者　担当名</div>
                    <div class="uploadCSVComponent_confirm_table_td">元付担当者　電話番号</div>
                    <div class="uploadCSVComponent_confirm_table_td">ポータル（楽待）</div>
                    <div class="uploadCSVComponent_confirm_table_td">ポータル（健美家）</div>
                    <div class="uploadCSVComponent_confirm_table_td">キャッチコピー</div>
                    <div class="uploadCSVComponent_confirm_table_td">管理用備考</div>
                    <div class="uploadCSVComponent_confirm_table_td">所在階</div>
                    <div class="uploadCSVComponent_confirm_table_td">向き</div>
                    <div class="uploadCSVComponent_confirm_table_td">専有面積</div>
                    <div class="uploadCSVComponent_confirm_table_td">バルコニー面積</div>
                    <div class="uploadCSVComponent_confirm_table_td">管理費（月額）</div>
                    <div class="uploadCSVComponent_confirm_table_td">修繕積立金（月額）</div>
                    <div class="uploadCSVComponent_confirm_table_td">管理方式</div>
                    <div class="uploadCSVComponent_confirm_table_td">管理会社名</div>
                    <div class="uploadCSVComponent_confirm_table_td">各住戸の専有面積</div>
                    <div class="uploadCSVComponent_confirm_table_td">住戸数</div>
                    <div class="uploadCSVComponent_confirm_table_td">その他の間取り</div>
                  </div>
                  <div class="uploadCSVComponent_confirm_table_row" v-for="(row, key) in insertTargetEstates" v-bind:key="key">
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.id }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.r_id }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.publish_status }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.admin_user_id }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.kind }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.build_name }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.open }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.trans_type }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.price }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.inv_rate }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.inv_income }}</div>
                    <!-- <div class="uploadCSVComponent_confirm_table_td">{{ row.zip }}</div> -->
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.prefecture }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.city }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.street_address }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.traffic }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.walk }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.structure }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.structure_other }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.story }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.build_date }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.build_confirm }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.build_size }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.inv_houses }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.floor_plan }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.parking }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.premises }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.company }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.rights }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.land_use }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.lie }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.land }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.setback }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.road_area }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.city_plan }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.use_land }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.road }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.status }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.timing }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.gas }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.suido }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.gesui }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.remark }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.hold_office }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.hold_office_tel }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.hold_charge }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.hold_charge_tel }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.portal_rakumachi }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.portal_kenbiya }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.catch }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.remark_staff }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.floor }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.facing }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.floor_size }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.balcony_size }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.manage_fee }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.repair_cost }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.manage_type }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.manage_office }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.build_house_size }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.build_houses }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.floor_plan_other }}</div>
                  </div>
                </div>
              </div>

              <h2 class="mt_30 col_green">更新対象 {{ updateTargetEstates.length }}件</h2>
              <div class="uploadCSVComponent_confirm_table_wrap mt_10">
                <div class="uploadCSVComponent_confirm_table">
                  <div class="uploadCSVComponent_confirm_table_row uploadCSVComponent_confirm_table__green">
                    <div class="uploadCSVComponent_confirm_table_td">管理番号</div>
                    <div class="uploadCSVComponent_confirm_table_td">REINS 物件番号</div>
                    <div class="uploadCSVComponent_confirm_table_td">掲載状況</div>
                    <div class="uploadCSVComponent_confirm_table_td">登録者</div>
                    <div class="uploadCSVComponent_confirm_table_td">物件種別</div>
                    <div class="uploadCSVComponent_confirm_table_td">物件名</div>
                    <div class="uploadCSVComponent_confirm_table_td">物件公開</div>
                    <div class="uploadCSVComponent_confirm_table_td">取引形態</div>
                    <div class="uploadCSVComponent_confirm_table_td">価格</div>
                    <div class="uploadCSVComponent_confirm_table_td">利回り</div>
                    <div class="uploadCSVComponent_confirm_table_td">年間賃貸収入</div>
                    <!-- <div class="uploadCSVComponent_confirm_table_td">郵便番号</div> -->
                    <div class="uploadCSVComponent_confirm_table_td">都道府県</div>
                    <div class="uploadCSVComponent_confirm_table_td">市区町村</div>
                    <div class="uploadCSVComponent_confirm_table_td">町域・番地以降</div>
                    <div class="uploadCSVComponent_confirm_table_td">交通</div>
                    <div class="uploadCSVComponent_confirm_table_td">交通の徒歩時間</div>
                    <div class="uploadCSVComponent_confirm_table_td">構造</div>
                    <div class="uploadCSVComponent_confirm_table_td">構造（補足）</div>
                    <div class="uploadCSVComponent_confirm_table_td">階数</div>
                    <div class="uploadCSVComponent_confirm_table_td">築年月（西暦）</div>
                    <div class="uploadCSVComponent_confirm_table_td">建築確認番号</div>
                    <div class="uploadCSVComponent_confirm_table_td">建築面積</div>
                    <div class="uploadCSVComponent_confirm_table_td">総戸数</div>
                    <div class="uploadCSVComponent_confirm_table_td">間取り</div>
                    <div class="uploadCSVComponent_confirm_table_td">駐車場</div>
                    <div class="uploadCSVComponent_confirm_table_td">駐車場台数</div>
                    <div class="uploadCSVComponent_confirm_table_td">施工会社</div>
                    <div class="uploadCSVComponent_confirm_table_td">土地権利</div>
                    <div class="uploadCSVComponent_confirm_table_td">地目</div>
                    <div class="uploadCSVComponent_confirm_table_td">地勢</div>
                    <div class="uploadCSVComponent_confirm_table_td">土地面積</div>
                    <div class="uploadCSVComponent_confirm_table_td">セットバック</div>
                    <div class="uploadCSVComponent_confirm_table_td">私道負担面積</div>
                    <div class="uploadCSVComponent_confirm_table_td">都市計画</div>
                    <div class="uploadCSVComponent_confirm_table_td">用途地域/建ぺい率/容積率</div>
                    <div class="uploadCSVComponent_confirm_table_td">接道状況/接道種別/接道方角/接道幅員</div>
                    <div class="uploadCSVComponent_confirm_table_td">現況</div>
                    <div class="uploadCSVComponent_confirm_table_td">引渡時期</div>
                    <div class="uploadCSVComponent_confirm_table_td">ガス</div>
                    <div class="uploadCSVComponent_confirm_table_td">水道</div>
                    <div class="uploadCSVComponent_confirm_table_td">下水</div>
                    <div class="uploadCSVComponent_confirm_table_td">備考</div>
                    <div class="uploadCSVComponent_confirm_table_td">元付業者　会社名</div>
                    <div class="uploadCSVComponent_confirm_table_td">元付業者　電話番号</div>
                    <div class="uploadCSVComponent_confirm_table_td">元付担当者　担当名</div>
                    <div class="uploadCSVComponent_confirm_table_td">元付担当者　電話番号</div>
                    <div class="uploadCSVComponent_confirm_table_td">ポータル（楽待）</div>
                    <div class="uploadCSVComponent_confirm_table_td">ポータル（健美家）</div>
                    <div class="uploadCSVComponent_confirm_table_td">キャッチコピー</div>
                    <div class="uploadCSVComponent_confirm_table_td">管理用備考</div>
                    <div class="uploadCSVComponent_confirm_table_td">所在階</div>
                    <div class="uploadCSVComponent_confirm_table_td">向き</div>
                    <div class="uploadCSVComponent_confirm_table_td">専有面積</div>
                    <div class="uploadCSVComponent_confirm_table_td">バルコニー面積</div>
                    <div class="uploadCSVComponent_confirm_table_td">管理費（月額）</div>
                    <div class="uploadCSVComponent_confirm_table_td">修繕積立金（月額）</div>
                    <div class="uploadCSVComponent_confirm_table_td">管理方式</div>
                    <div class="uploadCSVComponent_confirm_table_td">管理会社名</div>
                    <div class="uploadCSVComponent_confirm_table_td">各住戸の専有面積</div>
                    <div class="uploadCSVComponent_confirm_table_td">住戸数</div>
                    <div class="uploadCSVComponent_confirm_table_td">その他の間取り</div>
                  </div>
                  <div class="uploadCSVComponent_confirm_table_row" v-for="(row, key) in updateTargetEstates" v-bind:key="key">
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.id }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.r_id }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.publish_status }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.admin_user_id }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.kind }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.build_name }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.open }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.trans_type }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.price }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.inv_rate }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.inv_income }}</div>
                    <!-- <div class="uploadCSVComponent_confirm_table_td">{{ row.zip }}</div> -->
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.prefecture }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.city }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.street_address }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.traffic }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.walk }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.structure }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.structure_other }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.story }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.build_date }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.build_confirm }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.build_size }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.inv_houses }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.floor_plan }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.parking }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.premises }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.company }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.rights }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.land_use }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.lie }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.land }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.setback }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.road_area }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.city_plan }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.use_land }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.road }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.status }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.timing }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.gas }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.suido }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.gesui }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.remark }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.hold_office }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.hold_office_tel }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.hold_charge }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.hold_charge_tel }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.portal_rakumachi }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.portal_kenbiya }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.catch }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.remark_staff }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.floor }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.facing }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.floor_size }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.balcony_size }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.manage_fee }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.repair_cost }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.manage_type }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.manage_office }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.build_house_size }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.build_houses }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.floor_plan_other }}</div>
                  </div>
                </div>
              </div>

              <h2 class="mt_30 col_blue">新規登録・更新対象外 {{ exceptTargetEstates.length }}件</h2>
              <div class="uploadCSVComponent_confirm_table_wrap mt_10">
                <div class="uploadCSVComponent_confirm_table">
                  <div class="uploadCSVComponent_confirm_table_row uploadCSVComponent_confirm_table__blue">
                    <div class="uploadCSVComponent_confirm_table_td">管理番号</div>
                    <div class="uploadCSVComponent_confirm_table_td">REINS 物件番号</div>
                    <div class="uploadCSVComponent_confirm_table_td">掲載状況</div>
                    <div class="uploadCSVComponent_confirm_table_td">登録者</div>
                    <div class="uploadCSVComponent_confirm_table_td">物件種別</div>
                    <div class="uploadCSVComponent_confirm_table_td">物件名</div>
                    <div class="uploadCSVComponent_confirm_table_td">物件公開</div>
                    <div class="uploadCSVComponent_confirm_table_td">取引形態</div>
                    <div class="uploadCSVComponent_confirm_table_td">価格</div>
                    <div class="uploadCSVComponent_confirm_table_td">利回り</div>
                    <div class="uploadCSVComponent_confirm_table_td">年間賃貸収入</div>
                    <!-- <div class="uploadCSVComponent_confirm_table_td">郵便番号</div> -->
                    <div class="uploadCSVComponent_confirm_table_td">都道府県</div>
                    <div class="uploadCSVComponent_confirm_table_td">市区町村</div>
                    <div class="uploadCSVComponent_confirm_table_td">町域・番地以降</div>
                    <div class="uploadCSVComponent_confirm_table_td">交通</div>
                    <div class="uploadCSVComponent_confirm_table_td">交通の徒歩時間</div>
                    <div class="uploadCSVComponent_confirm_table_td">構造</div>
                    <div class="uploadCSVComponent_confirm_table_td">構造（補足）</div>
                    <div class="uploadCSVComponent_confirm_table_td">階数</div>
                    <div class="uploadCSVComponent_confirm_table_td">築年月（西暦）</div>
                    <div class="uploadCSVComponent_confirm_table_td">建築確認番号</div>
                    <div class="uploadCSVComponent_confirm_table_td">建築面積</div>
                    <div class="uploadCSVComponent_confirm_table_td">総戸数</div>
                    <div class="uploadCSVComponent_confirm_table_td">間取り</div>
                    <div class="uploadCSVComponent_confirm_table_td">駐車場</div>
                    <div class="uploadCSVComponent_confirm_table_td">駐車場台数</div>
                    <div class="uploadCSVComponent_confirm_table_td">施工会社</div>
                    <div class="uploadCSVComponent_confirm_table_td">土地権利</div>
                    <div class="uploadCSVComponent_confirm_table_td">地目</div>
                    <div class="uploadCSVComponent_confirm_table_td">地勢</div>
                    <div class="uploadCSVComponent_confirm_table_td">土地面積</div>
                    <div class="uploadCSVComponent_confirm_table_td">セットバック</div>
                    <div class="uploadCSVComponent_confirm_table_td">私道負担面積</div>
                    <div class="uploadCSVComponent_confirm_table_td">都市計画</div>
                    <div class="uploadCSVComponent_confirm_table_td">用途地域/建ぺい率/容積率</div>
                    <div class="uploadCSVComponent_confirm_table_td">接道状況/接道種別/接道方角/接道幅員</div>
                    <div class="uploadCSVComponent_confirm_table_td">現況</div>
                    <div class="uploadCSVComponent_confirm_table_td">引渡時期</div>
                    <div class="uploadCSVComponent_confirm_table_td">ガス</div>
                    <div class="uploadCSVComponent_confirm_table_td">水道</div>
                    <div class="uploadCSVComponent_confirm_table_td">下水</div>
                    <div class="uploadCSVComponent_confirm_table_td">備考</div>
                    <div class="uploadCSVComponent_confirm_table_td">元付業者　会社名</div>
                    <div class="uploadCSVComponent_confirm_table_td">元付業者　電話番号</div>
                    <div class="uploadCSVComponent_confirm_table_td">元付担当者　担当名</div>
                    <div class="uploadCSVComponent_confirm_table_td">元付担当者　電話番号</div>
                    <div class="uploadCSVComponent_confirm_table_td">ポータル（楽待）</div>
                    <div class="uploadCSVComponent_confirm_table_td">ポータル（健美家）</div>
                    <div class="uploadCSVComponent_confirm_table_td">キャッチコピー</div>
                    <div class="uploadCSVComponent_confirm_table_td">管理用備考</div>
                    <div class="uploadCSVComponent_confirm_table_td">所在階</div>
                    <div class="uploadCSVComponent_confirm_table_td">向き</div>
                    <div class="uploadCSVComponent_confirm_table_td">専有面積</div>
                    <div class="uploadCSVComponent_confirm_table_td">バルコニー面積</div>
                    <div class="uploadCSVComponent_confirm_table_td">管理費（月額）</div>
                    <div class="uploadCSVComponent_confirm_table_td">修繕積立金（月額）</div>
                    <div class="uploadCSVComponent_confirm_table_td">管理方式</div>
                    <div class="uploadCSVComponent_confirm_table_td">管理会社名</div>
                    <div class="uploadCSVComponent_confirm_table_td">各住戸の専有面積</div>
                    <div class="uploadCSVComponent_confirm_table_td">住戸数</div>
                    <div class="uploadCSVComponent_confirm_table_td">その他の間取り</div>
                  </div>
                  <div class="uploadCSVComponent_confirm_table_row" v-for="(row, key) in exceptTargetEstates" v-bind:key="key">
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.id }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.r_id }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.publish_status }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.admin_user_id }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.kind }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.build_name }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.open }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.trans_type }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.price }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.inv_rate }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.inv_income }}</div>
                    <!-- <div class="uploadCSVComponent_confirm_table_td">{{ row.zip }}</div> -->
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.prefecture }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.city }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.street_address }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.traffic }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.walk }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.structure }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.structure_other }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.story }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.build_date }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.build_confirm }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.build_size }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.inv_houses }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.floor_plan }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.parking }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.premises }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.company }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.rights }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.land_use }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.lie }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.land }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.setback }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.road_area }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.city_plan }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.use_land }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.road }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.status }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.timing }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.gas }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.suido }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.gesui }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.remark }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.hold_office }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.hold_office_tel }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.hold_charge }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.hold_charge_tel }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.portal_rakumachi }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.portal_kenbiya }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.catch }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.remark_staff }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.floor }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.facing }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.floor_size }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.balcony_size }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.manage_fee }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.repair_cost }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.manage_type }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.manage_office }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.build_house_size }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.build_houses }}</div>
                    <div class="uploadCSVComponent_confirm_table_td">{{ row.floor_plan_other }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </modal-window>
  </div>
</template>
<script>
export default {
  props:{
    uploadType:{},
    initDisabled:{},
  },
  data(){
    return {
      uploadedTxt: "ファイル選択もしくはドラッグ&ドロップ",
      updateTargetEstates:[],
      insertTargetEstates:[],
      exceptTargetEstates:[],
      isUploading:false,
      isSet:false,
      isError:false,
      isSuccess:false,
      files:[],
      dragZoneStyle:{},
      errorMessage:"",
      disabled:this.initDisabled,
      fileName: "",
    };
  },
  methods: {
    setFile(e){
      this.filesCount(e.target.files);
    },
    filesCount(files){
      if (files.length >= 1) {
        Array.from(files).forEach(file => {
          this.fileName += (file.name + '\n');
        });
        this.uploadedTxt = this.fileName;
        // this.uploadedTxt = `${files.length}件アップロード`;
        this.isSet       = true;
        this.files       = files;
      }
    },
    dragover(e){
      e.stopPropagation();
      e.preventDefault();

      this.dragZoneStyle.background = "#ff3399";
    },
    dragleave(e){
      e.stopPropagation();
      e.preventDefault();

      this.dragZoneStyle.background = "#ffffff";
    },
    drop(e){
      e.stopPropagation();
      e.preventDefault();

      this.dragZoneStyle.background = "#ffffff";

      var files = e.dataTransfer.files;
      this.filesCount(files);
    },

    /**
     * 確認アップロード
     */
    uploadConfirm(){
      try {
        this.upload('/cms/estate/batch/upload/check', (response) => {
          this.updateTargetEstates = response.data.update_target_estates;
          this.insertTargetEstates = response.data.insert_target_estates;
          this.exceptTargetEstates = response.data.except_target_estates;
        })
      } catch (error) {
        this.isError = true;
        this.errorMessage = error;
      }
    },

    /**
     * 保存アップロード
     */
    uploadStore(){
      try {
        this.upload('/cms/estate/batch/upload', () => {
          this.isSuccess = true;
        })
      } catch (error) {
        this.isError = true;
        this.errorMessage = error;
      }
    },

    /**
     * アップロード確認
     */
    upload(url, successCallback){
      let files = this.files;
      this.resetFlag();

      this.checkFilesType(files)

      // CSVをアップロードし、フィルタリングされたデータを表示
      if (files.length == 0) {
        return;
      }

      let formData = new FormData();
      for(let file of files){
        formData.append('files[]', file);
      }

      formData.append('upload_type', this.uploadType);

      let config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      };

      this.isUploading = true;

      axios
        .post(url, formData, config)
        .then((response) => {
          this.isUploading = false;

          if(response.data.success == false){
            throw new Error(response.data.error);
          }

          successCallback(response);
        })
        .catch((error) => {
          this.isUploading  = false;
          this.isError      = true;
          this.errorMessage = error;
        });
    },

    /**
     * ファイルタイプ確認
     */
    checkFilesType(files){
      for (const file of files) {
        if (file.type != 'text/csv') {
          throw new Error("アップロードできるファイルはCSVのみです。");
        }
      }
    },

    /**
     * エラーリセット
     */
    resetFlag(){
      this.isError     = false;
      this.isSuccess   = false;
    },
  },
}
</script>

<style lang="scss">
  .uploadCSVComponent{
    &_confirm{
      position: relative;
      height: 90vh;
      width: 90vw;
      background: white;
      padding: 30px;
      border-radius: 4px;
      // overflow-y: scroll;

      &_wrap{
        height: 100%;
      }

      &_table{
        width: max-content;
        display: grid;
        grid-template-columns: repeat(61, auto);
        &_list{
          overflow: scroll;
          max-height: calc(100% - 130px);
        }
        &_wrap{
          // border: 1px solid #000;
          border-radius: 4px;
        }
        &_row{
          display: contents;
          // display: grid;
          // width: max-content;
        }
        &_td{
          border: 1px solid #000;
          padding: 5px 10px ;
        }

        &__red{
          .uploadCSVComponent_confirm_table_td{
            background-color: #f5cbcc;
          }
        }
        &__blue{
          .uploadCSVComponent_confirm_table_td{
            background-color: #d0e2f3;
          }
        }
        &__green{
          .uploadCSVComponent_confirm_table_td{
            background-color: #deead6;
          }
        }
      }

      &_error{
        white-space: pre-line;
      }

      &_loading{
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        display: grid;
        place-content: center;
        justify-items: center;
        gap: 10px;
        background: #ffffff80;
        &_img{
          width: 50%;
          height: 505;
        }
        &_txt{
          display: grid;
          text-align: center;
          font-weight: bold;
          span{
            font-size: 12px;
            font-weight: normal;
          }
        }
      }

      &_submit{
        margin: 0 auto 30px !important;
        display: block;
      }
    }

  }
</style>